import React from 'react';
import { Box, Typography } from '@mui/material';
import CapabilityCard from './shared/CapabilityCard';
import GridContainer from './shared/GridContainer';
import HighlightBox from './shared/HighlightBox';
import FeatureList from './shared/FeatureList';
import ActionButton from './shared/ActionButton';

interface VoiceChatContentProps {
  onContentChange?: (contentId: string) => void;
  onActionClick?: (action: string, data?: any) => void;
}

const VoiceChatContent: React.FC<VoiceChatContentProps> = ({ onContentChange, onActionClick }) => {
  return (
    <Box>
      <Typography variant="h4" sx={{ fontFamily: 'var(--font-heading)', color: 'var(--primary-blue)', mb: 2 }}>
        🎤 Voice-Enabled AI Assistant
      </Typography>
      <Typography sx={{ fontFamily: 'var(--font-body)', color: 'var(--dark-gray)', mb: 3 }}>
        Engage in natural voice conversations for hands-free interaction and real-time assistance.
      </Typography>

      <CapabilityCard icon="🗣️" title="Voice Features">
        <FeatureList
          items={[
            'Real-time speech recognition',
            'Natural language processing',
            'Multi-language support',
            'Interview assistance mode',
            'Voice-to-text transcription',
            'Hands-free operation',
          ]}
        />
      </CapabilityCard>

      <HighlightBox>
        <Typography variant="h6" sx={{ fontFamily: 'var(--font-heading)', color: 'var(--primary-blue)', mb: 2 }}>
          🎯 Use Cases
        </Typography>
        <GridContainer>
          <CapabilityCard
            icon="📞"
            title="Interview Support"
            description="Get real-time assistance during interviews with voice-activated suggestions and note-taking."
          />

          <CapabilityCard
            icon="📝"
            title="Voice Notes"
            description="Capture thoughts and feedback using voice commands, automatically transcribed and organized."
          />
        </GridContainer>
      </HighlightBox>

      <Box sx={{ mt: 3 }}>
        <ActionButton onClick={() => onActionClick?.('start-voice-chat')}>
          Start Voice Chat
        </ActionButton>
        <ActionButton onClick={() => onActionClick?.('voice-settings')}>
          Voice Settings
        </ActionButton>
        <ActionButton onClick={() => onActionClick?.('test-microphone')}>
          Test Microphone
        </ActionButton>
      </Box>
    </Box>
  );
};

export default VoiceChatContent;

